import {defineRecipe} from '@chakra-ui/react3'

const chakraInputRecipe = defineRecipe({
    className: 'chakra-input',
    base: {
        width: '100%',
        minWidth: '0',
        outline: '0',
        position: 'relative',
        appearance: 'none',
        textAlign: 'start',
        borderRadius: 'l2',
        _disabled: {
            layerStyle: 'disabled'
        },
        height: 'var(--input-height)',
        minW: 'var(--input-height)',
        '--focus-color': 'colors.colorPalette.focusRing',
        '--error-color': 'colors.border.error',
        _invalid: {
            focusRingColor: 'var(--error-color)',
            borderColor: 'var(--error-color)'
        }
    },
    variants: {
        size: {
            '2xs': {
                textStyle: 'xs',
                px: '2',
                '--input-height': 'sizes.7'
            },
            xs: {
                textStyle: 'xs',
                px: '2',
                '--input-height': 'sizes.8'
            },
            sm: {
                textStyle: 'sm',
                px: '2.5',
                '--input-height': 'sizes.9'
            },
            md: {
                textStyle: 'sm',
                px: '3',
                '--input-height': 'sizes.10'
            },
            lg: {
                textStyle: 'md',
                px: '4',
                '--input-height': 'sizes.11'
            },
            xl: {
                textStyle: 'md',
                px: '4.5',
                '--input-height': 'sizes.12'
            },
            '2xl': {
                textStyle: 'lg',
                px: '5',
                '--input-height': 'sizes.16'
            }
        },
        variant: {
            outline: {
                bg: 'transparent',
                borderWidth: '1px',
                borderColor: 'border',
                focusVisibleRing: 'inside',
                focusRingColor: 'var(--focus-color)'
            },
            subtle: {
                borderWidth: '1px',
                borderColor: 'transparent',
                bg: 'bg.muted',
                focusVisibleRing: 'inside',
                focusRingColor: 'var(--focus-color)'
            },
            flushed: {
                bg: 'transparent',
                borderBottomWidth: '1px',
                borderBottomColor: 'border',
                borderRadius: '0',
                px: '0',
                _focusVisible: {
                    borderColor: 'var(--focus-color)',
                    boxShadow: '0px 1px 0px 0px var(--focus-color)',
                    _invalid: {
                        borderColor: 'var(--error-color)',
                        boxShadow: '0px 1px 0px 0px var(--error-color)'
                    }
                }
            }
        }
    },
    defaultVariants: {
        size: 'md',
        variant: 'outline'
    }
})

export const inputRecipe = defineRecipe({
    ...chakraInputRecipe,
    // prevents legacy chakra2 focus indicator from applying
    className: 'leap-input',
    base: {
        ...chakraInputRecipe.base,
        borderRadius: 's',
        boxShadow: 'none',
        '--focus-color': 'colors.border.strong',
        '--error-color': 'colors.border.system.error',
        '--input-height': '3.25rem',
        textStyle: 'body.medium',
        px: 'spacing-16',
        color: 'text.primary',
        _disabled: {
            ...chakraInputRecipe.base._disabled,
            opacity: 1,
            cursor: 'not-allowed'
        },
        _placeholder: {
            color: 'text.secondary',
            textStyle: 'body.medium'
        },
        _hover: {
            borderColor: 'border.medium'
        },
        _active: {
            borderColor: 'border.strong'
        },
        _focus: {
            borderColor: 'border.strong'
        },
        _focusVisible: {
            borderColor: 'border.strong'
        },
        _invalid: {
            borderColor: 'border.system.error',
            _hover: {
                borderColor: 'border.system.error'
            },
            _active: {
                borderColor: 'border.system.error'
            },
            _focus: {
                borderColor: 'border.system.error'
            },
            _focusVisible: {
                borderColor: 'border.system.error'
            }
        }
    },
    variants: {
        variant: {
            outline: {
                ...chakraInputRecipe.variants.variant.outline,
                bg: 'transparent',
                borderColor: 'border.subtle',
                focusVisibleRing: 'outside',
                focusRingColor: 'border.strong',
                focusRingWidth: '1px',
                focusRingStyle: 'solid'
            },
            filled: {
                ...chakraInputRecipe.variants.variant.subtle,
                bg: 'background.section.subtle',
                focusVisibleRing: 'outside',
                focusRingColor: 'border.strong',
                focusRingWidth: '1px',
                focusRingStyle: 'solid'
            }
        }
    },
    defaultVariants: {
        variant: 'outline'
    }
})
